// React
import * as React from 'react';

// Router
import { Link } from 'react-router-dom';

// Redux
import { connect } from 'react-redux';

// MainStore
import { MainStore } from '../stores/MainStore';
import { UserProfile_e } from "../framework/user/UserProfile";

// Components
import EnhancedTableHead from './DataTable/EnhancedTableHead';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import EnhancedTableToolbar from './DataTable/EnhancedTableToolbar';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Icon from '@material-ui/core/Icon';
import List from '@material-ui/core/List';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import { DateTimePicker } from 'material-ui-pickers';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import SelectAutocomplete from './SelectAutocomplete';
import { NetworkManager, MethodRequest_e } from '../managers/NetworkManager';
import ActionsMenu from './ActionsMenu';
import { getRole, Role } from '../framework/user/Role';

/**
 * @description Props Interface
 * @author Lucas Fridez <lucas@fridez.dev>
 * @interface Props
 */
interface Props {
    apiPath?: string;
    actions: Array<any>;
    columns: Array<any>;
    isPossibleToFilter: boolean;
    readonly?: boolean;
    navigation?: any;
    rows: string;
    title: string;
    view?: boolean;
    selectableFilter?: any;
    urlPath?: string;
}

interface State {
    anchorEl: any;
    damage: any;
    damageError: any;
    lastRowsPerPage: any;
    order: string;
    openAvailabilityModal: boolean;
    openDeleteModal: boolean;
    openConfirmModal: boolean;
    openCloseModal: boolean;
    orderBy: string;
    selected: Array<any>;
    data: Array<any>;
    filters: Array<any>;
    page: number;
    printFormat: string;
    returnDamagedMaterial: boolean;
    rowsPerPage: number;
    selectedItem: any;
    selectedWarehouse: any;
    warehouses: any;
}

/**
 * @author Lucas Fridez <lucas@fridez.dev>
 * @description Component DataTable
 */
export default connect<{}, {}, Props>((state) => state)(class DataTable extends React.Component<Props, State> {

    selectedItem: {
        damages: any,
        id: 0,
        name: "",
        visibility: any
    };

    /**
     * Creates an instance of DataTable.
     * @author Lucas Fridez <lucas@fridez.dev>
     * @param {*} props
     */
    constructor(props: any) {
        super(props);
        if (props.actions == undefined) {
            props.actions = [];
        }
        this.state = {
            anchorEl: null,
            damage: "",
            damageError: "",
            data: [],
            filters: [],
            lastRowsPerPage: 5,
            openAvailabilityModal: false,
            openCloseModal: false,
            openConfirmModal: false,
            openDeleteModal: false,
            order: 'asc',
            orderBy: 'id',
            page: 0,
            printFormat: "",
            returnDamagedMaterial: false,
            rowsPerPage: 5,
            selected: [],
            selectedItem: {
                damages: [],
                id: 0,
                name: "",
                visibility: true
            },
            selectedWarehouse: "",
            warehouses: []
        };
    }

    loadData = async () => {
        MainStore.showOverlay("Chargement des données");
        this.setState({
            data: await NetworkManager.request(this.props.rows, MethodRequest_e.GET),
            selected: []
        });
        MainStore.hideOverlay();
    }

    async componentWillMount() {
        this.loadData();
        this.props.columns.map((column: any) => {
            if (column.date) {
                this.setState((prevState) => ({
                    filters: {
                        ...prevState.filters,
                        [column.id]: {
                            filtering: column.filtering,
                            type: "date",
                            value: null
                        }
                    }
                }));
            }
            if (column.autocomplete) {
                this.setState((prevState) => ({
                    filters: {
                        ...prevState.filters,
                        [column.id]: {
                            label: "",
                            type: "autocomplete",
                            value: ""
                        }
                    }
                }));
            }
        });
    }

    shouldComponentUpdate(nextProps: Props, nextState: State) {
        if (this.props == nextProps && this.state == nextState) {
            return false;
        } else {
            return true;
        }
    }

    componentWillReceiveProps(nextProps: Props, nextState: State) {
        if (nextProps.selectableFilter) {
            this.setState((prevState) => ({
                filters: {
                    ...prevState.filters,
                    [nextProps.selectableFilter.name]: nextProps.selectableFilter.value
                }
            }));
        }
    }

    handleChangeFilter = () => {
        return (event: React.ChangeEvent<any>) => {
            const key = event.target.name;
            const value = event.target.value;
            this.setState((prevState) => ({
                filters: {
                    ...prevState.filters,
                    [key]: value
                }
            }));
        };
    }

    handleChangeAutocompleteFilter = (name: string) => {
        return (option: any) => {
            let opt: any;

            if (option) {
                opt = option;
            } else {
                opt = {
                    label: "",
                    value: ""
                };
            }
            this.setState((prevState) => ({
                filters: {
                    ...prevState.filters,
                    [name]: {
                        label: opt.label,
                        type: "autocomplete",
                        value: opt.value
                    }
                }
            }));
        };
    }
    handleChangeDamagedMaterial = () => {
        this.setState((prevState: State) => ({
            returnDamagedMaterial: !prevState.returnDamagedMaterial
        }));
    }

    handleResetFilter = (filter: string) => {
        return (event: React.ChangeEvent<any>) => {
            this.setState((prevState) => ({
                filters: {
                    ...prevState.filters,
                    [filter]: ""
                }
            }));
        };
    }

    handleRequestSort = (event: any, property: any) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        const data =
            order === 'desc'
                ? this.state.data.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
                : this.state.data.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));

        this.setState({ data, order, orderBy });
    }

    handleSelectAllClick = (event: any, checked: any) => {
        if (checked) {
            this.setState({ selected: this.state.data.map((n: any) => n.id) });
            return;
        }
        this.setState({ selected: [] });
    }

    closeBorrow = async (event: any) => {

        if (this.state.returnDamagedMaterial && this.state.damage == "") {
            this.setState({
                damageError: "Le dégât doit être indiqué."
            });
        } else {
            MainStore.showOverlay("Fermeture de l'emprunt en cours...");
            try {
                await NetworkManager.request(
                    `borrows/close`, MethodRequest_e.PUT, {
                    borrows: [{
                        bid: this.state.selectedItem.id,
                        damage: this.state.damage
                    }],
                    warehouse: this.state.selectedWarehouse
                }).then((response) => {
                    MainStore.showNotification(response.text);
                });
                this.loadData();
                this.handleCloseCloseModal();
            } catch (error) {
                MainStore.showNotification(error.text, "bg-col-error");
            } finally {
                MainStore.hideOverlay();
            }
        }
    }

    handleClick = (event: any, id: any) => {
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected: any = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }

        this.setState({ selected: newSelected });
    }

    handleChangePage = (event: any, page: any) => {
        this.setState({
            page: page
        });
    }

    handleChangeRowsPerPage = (event: any) => {
        this.setState({ rowsPerPage: event.target.value });
    }

    handleClickMenu = (event: any, id: any, row: any) => {
        this.setState({
            anchorEl: event.currentTarget,
            selectedItem: {
                id: id,
                name: row.name
            }
        });
        event.preventDefault(); event.stopPropagation();
    }

    handleCloseMenu = (event: any) => {
        this.setState({ anchorEl: null });
        event.preventDefault(); event.stopPropagation();
    }

    handleClickCloseModal = (event: any, id: any, row: any) => {
        this.handleCloseMenu(event);
        this.setState({
            openCloseModal: true,
            selectedItem: {
                damages: [],
                id: id,
                name: row.material,
                visibility: true
            }
        });
    }

    handleClickAvailibility = (event: any, id: any, row: any) => {
        this.handleCloseMenu(event);
        this.setState({
            openAvailabilityModal: true
        });
    }

    handleClickDelete = (event: React.MouseEvent<any>, id: any, row: any) => {
        let rowName;
        switch (this.props.apiPath) {
            case "users":
                rowName = `${row.name} ${row.surname}`; break;
            default:
                rowName = row.name;
                break;

        }
        this.handleCloseMenu(event);
        this.setState({
            selectedItem: {
                damages: [],
                id: id,
                name: rowName,
                visibility: true
            }
        });
        this.setState({
            openDeleteModal: true
        });
    }

    handleClickConfirm = (event: React.MouseEvent<any>, id: any, row: any) => {
        let rowName;
        switch (this.props.apiPath) {
            case "bookings":
                rowName = `${row.lastname} ${row.firstname}`; break;
            default:
                rowName = row.name;
                break;

        }
        this.handleCloseMenu(event);
        this.setState({
            selectedItem: {
                damages: [],
                id: id,
                name: rowName,
                visibility: true
            }
        });
        this.setState({
            openConfirmModal: true
        });
    }

    handleCloseCloseModal = () => {
        this.setState({
            openCloseModal: false,
            returnDamagedMaterial: false
        });
    }

    handleCloseDeleteModal = () => {
        this.setState({
            openDeleteModal: false
        });
    }

    handleCloseConfirmModal = () => {
        this.setState({
            openConfirmModal: false
        });
    }

    handleCloseAvailabilityModal = () => {
        this.setState({
            openAvailabilityModal: false
        });
    }

    handleChangeAvailibityModal = async (event: any) => {
        this.handleCloseAvailabilityModal();
        try {
            await NetworkManager.request(`${this.props.apiPath}/${this.state.selectedItem.id}/visibility`, MethodRequest_e.PUT).then((response) => {
                MainStore.showNotification(response.text);
            });
            this.loadData();
        } catch (error) {
            MainStore.showNotification(error.text, "bg-col-error");
        } finally {
            MainStore.hideOverlay();
        }
    }

    handleDeleteMaterial = async (event: any) => {
        this.handleCloseDeleteModal();
        try {
            await NetworkManager.request(`${this.props.apiPath}/${this.state.selectedItem.id}`, MethodRequest_e.DELETE).then((response) => {
                MainStore.showNotification(response.text);
            });
            this.loadData();
        } catch (error) {
            MainStore.showNotification(error.text, "bg-col-error");
        } finally {
            MainStore.hideOverlay();
        }
    }

    changeWarehouse = (event: any) => {
        this.setState({
            selectedWarehouse: event.target.value
        });
    }

    handleConfirmBooking = async(event: any) => {
        this.handleCloseConfirmModal();
        try {
            console.log(`${this.props.apiPath}/confirmed/${this.state.selectedItem.id}, ${this.props.apiPath}/confirmed/${this.state.selectedItem.id}`);
            await NetworkManager.request(`${this.props.apiPath}/confirmed/${this.state.selectedItem.id}`, MethodRequest_e.POST).then((response) => {
                MainStore.showNotification("Réservation confirmée !");
            });
            this.loadData();
        } catch (error) {
            MainStore.showNotification(error.text, "bg-col-error");
        } finally {
            MainStore.hideOverlay();
        }
    }

    isSelected = (id: any) => this.state.selected.indexOf(id) !== -1;

    renderActionCell = (id: any, row?: any) => {
        if (!this.props.readonly) {
            return (
                <TableCell numeric={true}>
                    {(this.props.actions.indexOf("update") > -1 && ((this.props.apiPath == "users" && NetworkManager.getUserProfile() == UserProfile_e.ADMIN) || this.props.apiPath != "users")) &&
                        <Link to={`${this.props.urlPath}/Modifier/${id}`}
                            onClick={MainStore.updateActualView(`${this.props.urlPath}/Afficher/${id}`)}>
                            <Button variant="fab" mini={true} color="inherit" aria-label="modifier" className="btn btn-orange">
                                <Icon>edit</Icon>
                            </Button>
                        </Link >
                    }
                    {(this.props.actions.indexOf("delete") > -1 && ((this.props.apiPath == "users" && NetworkManager.getUserProfile() == UserProfile_e.ADMIN) || this.props.apiPath != "users")) &&
                        <Button variant="fab" mini={true} color="secondary" aria-label="supprimer" className="btn"
                            onClick={(e) => this.handleClickDelete(e, id, row)}>
                            <Icon>delete</Icon>
                        </Button>
                    }
                    {(this.props.actions.indexOf("confirm") > -1 &&
                    getRole(JSON.parse(window.sessionStorage.getItem("userCredentials")|| "{role_id: 0}").role_id) == Role.President) &&
                    row.confirmed == "Non confirmé" &&
                        <Button variant="fab" mini={true} color="primary" aria-label="confirm" className="btn"
                            onClick={(e) => this.handleClickConfirm(e, id, row)}>
                            <Icon>check</Icon>
                        </Button>
                    }
                    {this.props.actions.indexOf("stock") > -1 &&
                        <Link to={`${this.props.urlPath}/Stock/${id}`}
                            onClick={MainStore.updateActualView(`${this.props.urlPath}/Stock/${id}`)}>
                            <Button variant="fab" mini={true} color="primary" aria-label="afficher stock">
                                <Icon>view_list</Icon>
                            </Button>
                        </Link >
                    }
                    {this.props.actions.indexOf("more") > -1 &&
                        <Button variant="fab" mini={true} color="primary" aria-label="plus" className="btn"
                            onClick={(e) => this.handleClickMenu(e, id, row)}>
                            <MoreVertIcon />
                        </Button>
                    }
                    {this.props.actions.indexOf("close") > -1 && row.status == "en cours" &&
                        <Button variant="fab" mini={true} color="primary" aria-label="plus" className="btn"
                            onClick={(e) => this.handleClickCloseModal(e, id, row)}>
                            <Icon>check</Icon>
                        </Button>
                    }
                </TableCell >
            );
        } else {
            return null;
        }
    }
    /**
     * @description Render the AppBar Component
     * @author Lucas Fridez <lucas@fridez.dev>
     * @returns
     */
    render() {
        const { columns, isPossibleToFilter, title, readonly, view } = this.props;
        const { filters, openCloseModal, openDeleteModal, order, openConfirmModal,
            orderBy, selected, rowsPerPage, page, selectedWarehouse, returnDamagedMaterial } = this.state;
        let data = this.state.data;

        data = data.filter((element, index, array) => {
            let isFiltered = true;
            Object.keys(filters).forEach((filter: any) => {
                if (isFiltered) {
                    if (filters[filter].type == "date") {
                        if (filters[filter].value != null) {
                            const date: string = element[filter];
                            const correctStringDate = date.substr(3, 2) + "." + date.substr(0, 2) + date.substr(5);
                            if (filters[filter].filtering == ">") {
                                isFiltered = new Date(correctStringDate) > new Date(filters[filter].value);
                            } else {
                                isFiltered = new Date(correctStringDate) < new Date(filters[filter].value);
                            }
                        }
                    } else if (filters[filter].type == "autocomplete") {
                        if (filters[filter].value == "") {
                            isFiltered = true;
                        } else {
                            isFiltered = element[filter] == filters[filter].label;
                        }
                    } else {
                        //isFiltered = element[filter].toString().toLowerCase().includes(filters[filter].toString().toLowerCase());
                    }
                }
            });
            return isFiltered;
        });

        const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);
        return (
            <Paper>
                <EnhancedTableToolbar numSelected={selected.length} selectedIds={selected} title={title} loadData={this.loadData}
                    readonly={readonly} view={view} urlPath={this.props.urlPath} apiPath={this.props.apiPath} />
                <div style={{ overflowX: "auto" }}>
                    <Table aria-labelledby="tableTitle">
                        <EnhancedTableHead
                            columns={columns}
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={this.handleSelectAllClick}
                            onRequestSort={this.handleRequestSort}
                            readonly={readonly}
                            rowCount={data.length}
                        />
                        <TableBody>
                            {isPossibleToFilter && <TableRow>
                                <TableCell>&nbsp;</TableCell>
                                {columns.map((column: any) => {
                                    if (column.id != "id") {
                                        return (
                                            <TableCell
                                                key={column.id}
                                                numeric={column.numeric}
                                                padding={column.disablePadding ? 'none' : 'dense'}
                                            >
                                                {column.select &&
                                                    <TextField
                                                        name={column.id}
                                                        select={true}
                                                        value={this.state.filters[column.id] || ""}
                                                        label="Filtrer..."
                                                        onChange={this.handleChangeFilter()}
                                                        fullWidth={true}
                                                    >
                                                        <MenuItem value={""}>Aucun</MenuItem>
                                                        {column.options.map((option: string, key: number) => {
                                                            return (<MenuItem value={option} key={key}>{option}</MenuItem>);
                                                        })}
                                                    </TextField>
                                                }
                                                {column.autocomplete &&
                                                    <SelectAutocomplete
                                                        name={column.id}
                                                        label=""
                                                        placeholder="Filtrer..."
                                                        value={filters[column.id].value}
                                                        onChange={this.handleChangeAutocompleteFilter(column.id)}
                                                        options={column.options} />
                                                }
                                                {!column.select && !column.date && !column.noFilter && !column.autocomplete &&
                                                    <TextField
                                                        label={"Filtrer..."}
                                                        name={column.id}
                                                        value={filters[column.id] || ""}
                                                        onChange={this.handleChangeFilter()}
                                                        InputProps={{
                                                            endAdornment:
                                                                <InputAdornment position="end">
                                                                    <IconButton color="inherit"
                                                                        aria-label="Effacer le filtre"
                                                                        style={{ height: "32px", width: "32px" }}
                                                                        onClick={this.handleResetFilter(column.id)}>
                                                                        <Icon>clear</Icon>
                                                                    </IconButton>
                                                                </InputAdornment>
                                                        }}
                                                    />}
                                                {column.date &&
                                                    <DateTimePicker
                                                        value={filters[column.id].value || null}
                                                        format="DD.MM.YYYY hh:mm"
                                                        disableFuture={filters[column.id].filtering == "<"}
                                                        ampm={false}
                                                        clearable={true}
                                                        cancelLabel="Annuler"
                                                        clearLabel="Suppr. date"
                                                        onChange={(date) => {
                                                            this.setState((prevState) => ({
                                                                filters: {
                                                                    ...prevState.filters,
                                                                    [column.id]: {
                                                                        filtering: column.filtering,
                                                                        type: "date",
                                                                        value: date
                                                                    }
                                                                }
                                                            }));
                                                        }}
                                                        label="Filtrer..."
                                                    />}
                                            </TableCell>
                                        );
                                    } else {
                                        return null;
                                    }
                                }, this)}
                                {!this.props.readonly && <TableCell>&nbsp;</TableCell>}
                            </TableRow>}
                            {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((n: any) => {
                                const isSelected = this.isSelected(n.id);
                                return (
                                    <TableRow
                                        hover={true}
                                        onClick={!readonly ? (event) => this.handleClick(event, n.id) : undefined}
                                        role="checkbox"
                                        aria-checked={isSelected}
                                        tabIndex={-1}
                                        key={n.id}
                                        selected={isSelected}
                                    >
                                        <TableCell padding="checkbox">
                                            {!readonly && <Checkbox checked={isSelected} color="primary" />}
                                        </TableCell>
                                        {columns.map((column: any, key: number) => {
                                            if (column.id != "id" && column.id.indexOf("date") == -1) {
                                                return (
                                                    <TableCell key={key} numeric={n[column.numeric]} padding="dense">{n[column.id]}</TableCell>
                                                );
                                            } else if (column.id.indexOf("date") > -1) {
                                                return (
                                                    <TableCell key={key} numeric={n[column.numeric]} padding="dense">{new Date(n[column.id]).toLocaleDateString()}</TableCell>
                                                );
                                            } else {
                                                return null;
                                            }
                                        })}
                                        {this.renderActionCell(n.id, n)}
                                    </TableRow>
                                );
                            })}
                            {emptyRows > 0 && (
                                <TableRow style={{ height: 49 * 1 }}>
                                    <TableCell colSpan={7} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </div>
                <ActionsMenu
                    anchorEl={this.state.anchorEl}
                    id={this.state.selectedItem ? this.state.selectedItem.id : ""}
                    handleClose={this.handleCloseMenu}
                    handleClickAvailability={this.handleClickAvailibility}
                    handleClickBarcode={() => { console.log("OK"); }}
                    urlPath={this.props.urlPath}
                />
                <TablePagination
                    component="div"
                    count={data.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonProps={{
                        'aria-label': 'Page précédente'
                    }}
                    labelRowsPerPage="Lignes"
                    labelDisplayedRows={({ from, to, count }) => `${from} à ${to} sur ${count}`}
                    nextIconButtonProps={{
                        'aria-label': 'Page suivante'
                    }}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />

                <Dialog
                    aria-labelledby="delete-modal"
                    aria-describedby="delete-modal"
                    disableAutoFocus={true}
                    open={openDeleteModal}
                    onClose={this.handleCloseDeleteModal}>
                    <DialogTitle>Suppression</DialogTitle>
                    <DialogContent>
                        <Typography variant="body1" gutterBottom={true}>
                            Êtes-vous sûr de vouloir supprimer l'élément <strong>{this.state.selectedItem ? this.state.selectedItem.name : ""}</strong> ?
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseDeleteModal}>Annuler</Button>
                        <Button color="secondary" onClick={this.handleDeleteMaterial}>Supprimer</Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    aria-labelledby="delete-modal"
                    aria-describedby="delete-modal"
                    disableAutoFocus={true}
                    open={openConfirmModal}
                    onClose={this.handleCloseConfirmModal}>
                    <DialogTitle>Confirmer la réservation</DialogTitle>
                    <DialogContent>
                        <Typography variant="body1" gutterBottom={true}>
                            Êtes-vous sûr de vouloir confirmer la réservation de <strong>{this.state.selectedItem ? this.state.selectedItem.name : ""}</strong> ?
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseConfirmModal}>Annuler</Button>
                        <Button color="primary" onClick={this.handleConfirmBooking}>Confirmer</Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    aria-labelledby="close-borrow-modal"
                    aria-describedby="close-borrow-modal"
                    disableAutoFocus={true}
                    open={openCloseModal}
                    onClose={this.handleCloseCloseModal}>
                    <DialogTitle>Clôturer l'emprunt</DialogTitle>
                    <DialogContent>
                        <Typography variant="body1" gutterBottom={true}>
                            Sélectionner l'entrepôt dans lequel le matériel <strong>{this.state.selectedItem.name}</strong> sera déposé.
                        </Typography>
                        <List>
                            <RadioGroup
                                aria-label="gender"
                                name="gender2"
                                value={selectedWarehouse}
                                onChange={this.changeWarehouse}
                            >
                                {this.state.warehouses.map((warehouse: any, key: any) => {
                                    return (
                                        <FormControlLabel key={key} value={warehouse.id} control={<Radio color="primary" />}
                                            label={warehouse.name} />
                                    );
                                })}
                            </RadioGroup>
                        </List>
                        <FormControlLabel
                            control={<Switch color="primary" value="damagedMaterial" />}
                            onChange={this.handleChangeDamagedMaterial}
                            label="Dégât apparant lors de la remise du matériel"
                            checked={returnDamagedMaterial} />
                        {returnDamagedMaterial &&
                            <TextField
                                fullWidth={true}
                                id="multiline-static"
                                value={this.state.damage}
                                error={Boolean(this.state.damageError)}
                                helperText={this.state.damageError}
                                label="Dégât"
                                multiline={true}
                                margin="normal"
                                onChange={(e) => { this.setState({ damage: e.target.value }); }}
                            />
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseCloseModal}>Annuler</Button>
                        <Button color="primary" disabled={selectedWarehouse == 0} onClick={this.closeBorrow}>Clôturer</Button>
                    </DialogActions>
                </Dialog>
            </Paper >
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/components/DataTable.tsx